import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { authFB } from '../../helpers/Firebase';
import { servicePath } from '../../constants/defaultValues';
import { NotificationManager } from '../../components/common/react-notifications';
import {
    TASK_EQUIPMENT_LIST_DELIVERY_PLAN,
    EQUIPMENT_MODEL_UPDATE,
    EQUIPMENT_UNIT_UPDATE
} from '../actions';
import {
    TaskEquipmentListDeliveryPlanSuccess,
    TaskEquipmentListDeliveryPlanError,
    EquipmentModelUpdateSuccess,
    EquipmentModelUpdateError,
    EquipmentUnitUpdateSuccess,
    EquipmentUnitUpdateError
} from '../actions';

function getToken(auth) {
    return new Promise((resolve, reject) => {
        const unsubscribe = auth.onAuthStateChanged(user => {
            user.getIdToken().then((token) => {
                unsubscribe();
                resolve(token);
            });
        }, reject);
    });
}

// LIST DELIVERY PLAN
const onTaskEquipmentListDeliveryPlanAsync = async (payload) => {
    const token = await getToken(authFB);
    const response = await fetch(servicePath + 'task-equipment/delivery-plan/list', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    }).then(res => res.json()).catch(err => console.log(err));
    return { data: response };
};

function* onTaskEquipmentListDeliveryPlan(action) {
    try {
        const response = yield call(onTaskEquipmentListDeliveryPlanAsync, action.payload);
        yield put(TaskEquipmentListDeliveryPlanSuccess(response.data.data));
    } catch (error) {
        yield put(TaskEquipmentListDeliveryPlanError(error));
    }
}

function* watchTaskEquipmentListDeliveryPlan() { yield takeEvery(TASK_EQUIPMENT_LIST_DELIVERY_PLAN, onTaskEquipmentListDeliveryPlan); }

// EQUIPMENT MODEL UPDATE
const onEquipmentModelUpdateAsync = async (payload) => {
    console.log('onEquipmentModelUpdateAsync', payload)
    const token = await getToken(authFB);
    const response = await fetch(servicePath + 'equipment_model/update', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    }).then(res => res.json()).catch(err => console.log(err));
    return { data: response };
};

function* onEquipmentModelUpdate(action) {
    try {
        const response = yield call(onEquipmentModelUpdateAsync, action.payload);
        if (response.data.status === true) {
            NotificationManager.success(response.data.message, 'Exito', 500, null, null, '');
        }
        yield put(EquipmentModelUpdateSuccess(response.data));
    } catch (error) {
        yield put(EquipmentModelUpdateError(error));
    }
}

function* watchEquipmentModelUpdate() { yield takeEvery(EQUIPMENT_MODEL_UPDATE, onEquipmentModelUpdate); }

// EQUIPMENT UNIT UPDATE
const onEquipmentUnitUpdateAsync = async (payload) => {
    const token = await getToken(authFB);
    const response = await fetch(servicePath + 'equipment-unit/update', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    }).then(res => res.json()).catch(err => console.log(err));
    return { data: response };
};

function* onEquipmentUnitUpdate(action) {
    try {
        const response = yield call(onEquipmentUnitUpdateAsync, action.payload);
        if (response.data.status === true) {
            NotificationManager.success(response.data.message, 'Exito', 500, null, null, '');
        }
        yield put(EquipmentUnitUpdateSuccess(response.data));
    } catch (error) {
        yield put(EquipmentUnitUpdateError(error));
    }
}

function* watchEquipmentUnitUpdate() { yield takeEvery(EQUIPMENT_UNIT_UPDATE, onEquipmentUnitUpdate); }

export default function* rootSaga() {
    yield all([
        fork(watchTaskEquipmentListDeliveryPlan),
        fork(watchEquipmentModelUpdate),
        fork(watchEquipmentUnitUpdate)
    ]);
}
